var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyProfile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 94,
  height: 94,
  viewBox: "0 0 94 94",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "5b6t8vn44a",
  cx: 47,
  cy: 47,
  r: 47
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-210 -281) translate(210 281)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "0wvx45e79b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#5b6t8vn44a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#F9FBFF",
  xlinkHref: "#5b6t8vn44a"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 35,
  r: 16,
  fill: "#D8DFEE",
  mask: "url(#0wvx45e79b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 84,
  r: 30,
  fill: "#D8DFEE",
  mask: "url(#0wvx45e79b)"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyProfile);
export default ForwardRef;